<template>
    <v-container id="regular-tables" fluid tag="section" style="font-size:10px">
        <base-material-card color="#ed3325" icon="mdi-clipboard-text" title="Movimientos" class="px-5 py-3">
        <v-row dense>
          <v-col cols="12" sm="6" md="4">
            <v-text-field label="Folio" outlined dense v-model="folioB" hide-details="auto"></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <v-text-field type="date" label="Fecha inicio" outlined dense v-model="finicio" hide-details="auto"></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <v-text-field type="date" label="Fecha fin" outlined dense v-model="ffin" hide-details="auto"></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <v-btn color="green" @click="getMovimientos()"> Buscar </v-btn>
            <v-btn color="blue" outlined @click="limpiarFiltros()"> Limpiar filtros </v-btn>
          </v-col>
        </v-row>
        <v-data-table :headers="headers" :items="items" :items-per-page="25" :loading="loading"> 
          <template v-slot:[`item.estatus`]="{ item }">
            <v-chip class="ma-2" color="green" text-color="white" small>
              {{item.estatus}}
            </v-chip>
          </template>
          <template v-slot:[`item.acciones`]="{ item }">
            <v-btn color="primary" fab small dark @click="verReportePagos(item)">
              <v-icon>mdi-file</v-icon>
            </v-btn>
          </template>
        </v-data-table>
        </base-material-card>

        <v-dialog v-model="dialogPDF" fullscreen hide-overlay transition="dialog-bottom-transition" :loading="true">
          <v-card>
            <v-toolbar dark color="primary">
              <v-btn icon dark @click="dialogPDF = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <v-toolbar-title>Visualizador PDF</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-btn dark text @click="savePDF()">
                  <v-icon>mdi-content-save</v-icon>
                </v-btn>
              </v-toolbar-items>
            </v-toolbar>
             <iframe :src="urlPDF" title="Cotizacion" :height="height" width="100%" type="application/pdf" />
          </v-card>
        </v-dialog>

    </v-container>
</template>

<script>
import axios from 'axios';
import moment from 'moment';

export default {
  name: 'DocumentadorMovimientos',

  data() {
    return {
        headers: [
          { text: 'Folio', value: 'num_recepfact', },
          { text: 'Monto Pago Global', value: 'MontoPagoGlobal' },
          { text: 'Fecha pago', value: 'fecha_pago' },
          { text: 'Estatus', value: 'estatus' },
          { text: 'Acciones', value: 'acciones' },
        ],
        items: [],
        dialogPDF:false,
        urlPDF:'',
        height:0,
        loading:true,
        folioB:'',
        finicio:(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        ffin:(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    };
  },

  mounted() {
    this.height = window.innerHeight - 70
    this.getMovimientos()
  },

  methods: {
    async getMovimientos(){
      this.loading = true
      try {
        const id_p = localStorage.getItem('proveedor_id') ? localStorage.getItem('proveedor_id') : 0
        await axios.post('/solicitud/movimientos', {id_proveedor: id_p, folio:this.folioB, fini:this.finicio, ffin:this.ffin}).then(resp =>{
          const { data } = resp
          data.forEach(element => {
            element.MontoPagoGlobal = this.formatPrice(element.MontoPagoGlobal)
            element.estatus = this.changeEstatusString(Number(element.estatus))
            element.fecha_pago =  moment(element.fecha_pago).format('Y-MM-DD');
          });
        this.items = data
        this.loading = false
      })
      } catch(e) {
        this.loading = false
      }
    },
    formatPrice(value) {
        var formatter = new Intl.NumberFormat('es-MX', {
            style: 'currency',
            currency: 'MXN',
            minimumFractionDigits: 2
        });
        return formatter.format(value);
    },
    changeEstatusString(val){
      var est = ''
      switch (val) {
        case 4:
          est = 'Pagado'
          break;
        default:
          break;
      }
      return est
    },
    async verReportePagos(item) {
      this.urlPDF = ''
      this.dialogPDF = true
      const prov = localStorage.getItem('nombre')
      await axios.post('/solicitud/getPagosByFolio',{folio:item.num_recepfact, proveedor:prov, monto_g:item.MontoPagoGlobal}, { responseType: 'blob' }).then(resp => {
        const blob = new Blob([resp.data], { type: 'application/pdf' });
        const objectUrl = URL.createObjectURL(blob);
        this.urlPDF = objectUrl
      })
    },
    limpiarFiltros(){
      this.folioB = ''
      this.getMovimientos()
    }
  },
};
</script>